import { Fragment } from "react";
import { Link } from "react-router-dom";
import { Button } from "rizzui";
import { usePrivilege } from "../../../components/priviledge/PriviledgeProvider";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import PageHeader from "../../../layout/shared/page-header";
import { menuRoutes } from "../../../router/menu";
import InvoicesList from "./InvoicesList";

const InvoicesListWrapper = () => {
    const { userCan } = usePrivilege();

    const breadCrumb = [
        { name: 'Ventas' },
        { name: 'Gestión de facturas' },
        { name: 'Facturas', href: menuRoutes.invoices.path },
    ];

    return (
        <Fragment>
            <FiltersProvider>
                <PageHeader title="Listado de facturas" breadcrumb={breadCrumb}>
                    {userCan('create_invoices', 'invoices') && (
                        <Link to={`${menuRoutes.invoices.path}/${menuRoutes.invoices.nonStandard}`}>
                            <Button size="sm">Nueva factura atípica</Button>
                        </Link>
                    )}
                </PageHeader>
                <InvoicesList />
            </FiltersProvider>
         </Fragment>
    );
}

export default InvoicesListWrapper;
